/**
 * Labstep
 *
 * @module components/Layout/RightPane
 * @desc Elements Overview
 */

import { RightPaneIndex as RightPaneIndexPage } from 'labstep-web/components/Layout/RightPane/IndexPage';
import { RightPaneSubPageContainer as RightPaneSubPage } from 'labstep-web/components/Layout/RightPane/SubPage';
import { MediaQueryDesktop as Desktop } from 'labstep-web/core/MediaQuery/Desktop';
import Route from 'labstep-web/core/Route';
import { navigation } from 'labstep-web/services/navigation';
import type { IRouting } from 'labstep-web/services/navigation.types';
import { objectOrFunction } from 'labstep-web/services/react.service';
import type React from 'react';
import { Switch } from 'react-router-dom';
import type { RightPaneProps } from './types';

// Add more paths to match with route
export const getPath = (
  to: keyof IRouting,
  paths?: string[],
): string | string[] =>
  paths ? [navigation.get(to), ...paths] : navigation.get(to);

export const RightPane: React.FC<RightPaneProps> = ({
  route,
  paths,
  subPages,
  subPagesNested,
}) => (
  <Desktop>
    {({ match }): React.ReactElement => (
      <Switch>
        <Route
          exact
          path={getPath(route.to, paths)}
          render={(): React.ReactElement => (
            <RightPaneIndexPage subPages={subPages} desktop={match} />
          )}
        />
        {subPages.map((page) => (
          <Route
            exact
            key={page.route.to}
            path={getPath(page.route.to, page.paths)}
            render={(): React.ReactElement => (
              <RightPaneSubPage
                header={page.name}
                icon={page.icon}
                expanded={page.expanded}
                backRoute={route}
              >
                {page.component}
              </RightPaneSubPage>
            )}
          />
        ))}
        {subPagesNested?.map((page) => (
          <Route
            exact
            key={page.route.to}
            path={getPath(page.route.to, page.paths)}
            render={(props): React.ReactElement => (
              <RightPaneSubPage
                header={page.name(props)}
                icon={page.icon}
                backRoute={{
                  ...objectOrFunction(page.backRoute, props),
                  params: props.match.params,
                }}
              >
                {page.component(props)}
              </RightPaneSubPage>
            )}
          />
        ))}
      </Switch>
    )}
  </Desktop>
);
